export class DadosBancarios{
    Banco: string;
    Agencia: string;
    Operacao: string ;
    Conta: string;

    constructor(){}
}